import React from 'react';
import Component from '@/Component';
import { isMobile } from "react-device-detect";
import starbugs from '@/static/img/starbugs.jpg';
import paik from '@/static/img/paik.jpg';
import ferrero from '@/static/img/ferrero.jpg';
import mahogany from '@/static/img/mahogany.jpg';

class Donation extends Component {

  state = {
    isOpen: false
  }

  toggleDonationDetail() {
    this.setState((prevState)=>({
      isOpen: !prevState.isOpen
    }))
  }

  render() {
    return (
      <div>
      {isMobile ? 
        <div className="main">
          <hr />
          <h5><a onClick={this.toggleDonationDetail} tabIndex={100}><b>Donation</b></a></h5>
          <div className="row" style={{display: this.state.isOpen ? 'flex' : 'none', marginTop: 20}}>
            <div className="col-6 col-md-3">
              <a href="https://emoticon.kakao.com/items/oY7G64t3WPdn1B60XxcGq-W2hYE=?lang=ko&referer=share_link" className="thumbnail">
                <img src="https://item.kakaocdn.net/do/5dca74777bc3aabe4e208f47c12e9b74f43ad912ad8dd55b04db6a64cddaf76d" alt="이모티콘" />
              </a>
            </div>
            <div className="col-6 col-md-3">
              <a href="https://emoticon.kakao.com/items/9vMmlqGByLaamMFXXQkj3afGBXM=?lang=ko&referer=share_link" className="thumbnail">
                <img src="https://item.kakaocdn.net/do/4a94cbfc44db14a9cab16b99b0c8bd8af43ad912ad8dd55b04db6a64cddaf76d" alt="이모티콘" />
              </a>
            </div>
            <div className="col-6 col-md-3">
              <a href="https://gift-talk.kakao.com/appredirect?item_id=859901" className="thumbnail">
                <img src={starbugs} alt="스벅" />
              </a>
            </div>
            <div className="col-6 col-md-3">
              <a href="https://gift-talk.kakao.com/appredirect?item_id=352563" className="thumbnail">
                <img src={paik} alt="빽" />
              </a>
            </div>
          </div>
        </div>
      : null}
      </div>
    )
  }
}

export default Donation;



// WEBPACK FOOTER //
// ./src/components/common/Donation.js